/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 01/12/24
 *
 */

import {create} from "vue3-modal-dialogs"
import {tryReloadOnChunkLoadFailed} from "@/utils/helpers.js";

// Deprecated. Use createDialogLazy instead
export function createDialog(component, ...args){
	return create(component, ...args)
}

export function createDialogLazy(componentImportFn, ...createDialogArgs){
	let dialogInstance = null
	return async function () {
		if(!dialogInstance){
			let component
			try{
				component = await componentImportFn()
			} catch (error) {
				tryReloadOnChunkLoadFailed(error)
				throw error
			}
			component = component.default || component
			dialogInstance = create(component, ...createDialogArgs)
		}
		return dialogInstance(...arguments) //we need to use function(){}, not ()=>{}, because we need to pass "arguments" of the inner function. Otherwise, "arguments" will refer to the outer function "createDialogLazy"
	}
}

//doesnt work with paths with aliases...
export function createDialogLazyByPath(componentImportPath, ...createDialogArgs){
	return createDialogLazy(() => import(componentImportPath), ...createDialogArgs)
}

export function createDrawer(component, options = {}){
	return create({
		component,
		...options
	})
}
